<script lang="ts">
	import translations from "./RecaptchaDisclaimer.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";

	const translate = getTranslate(translations);

	let disclaimerClass = "";
	export { disclaimerClass as class };
</script>

<div class="text-2xs/none text-bito-black text-center tracking-[0.02em] {disclaimerClass}">
	{translate("text")}
	<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" class="underline"
		>{translate("privacyPolicy")}</a
	>
	{translate("and")}
	<a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" class="underline"
		>{translate("terms")}</a
	>
	{translate("company")}
</div>
